import { ADMIN_SUPPORT_MODULE_ID } from "constants/constants";

const UPLOAD_SERVICE_URL = process.env.REACT_APP_UPLOAD_SERVICE_URL?.trim() ?? "";
const UPLOAD_SERVICE_SECRET_KEY =
  process.env.REACT_APP_UPLOAD_SERVICE_SECRET_KEY ?? "";

const buildUrl = (path, searchParams = {}) => {
  const baseUrl = UPLOAD_SERVICE_URL.replace(/\/$/, "");
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  const url = new URL(normalizedPath, `${baseUrl}/`);

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, String(value));
    }
  });

  return url;
};

const getHeaders = (additionalHeaders = {}) => ({
  accept: "application/json",
  "secret-key": UPLOAD_SERVICE_SECRET_KEY,
  ...additionalHeaders,
});

export const uploadScriptFile = async ({ selectedFile, userId, scriptId }) => {
  const url = buildUrl("/upload-file", {
    uploaded_by: userId,
    selected_script_id: scriptId,
  });

  const formData = new FormData();
  formData.append("file", selectedFile);

  const response = await fetch(url, {
    method: "POST",
    headers: getHeaders(),
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.message || `Failed to upload file. Status: ${response.status}`
    );
  }

  const data = await response.json();

  if (data.status === "success") {
    return data.data;
  }

  throw new Error(
    data.message || "An error occurred while uploading the file."
  );
};

export const fetchUploadHistory = async (userId) => {
  const url = buildUrl("/get-all-files", {
    uploader_user_id: userId,
    module_id: ADMIN_SUPPORT_MODULE_ID,
  });

  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders({
      "Content-Type": "application/json",
    }),
    body: null,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.message || `Failed to fetch history. Status: ${response.status}`
    );
  }

  const data = await response.json();

  if (data.status === "success") {
    return data.data;
  }

  throw new Error(
    data.message || "An error occurred while fetching upload history."
  );
};

export const fetchProcessedFile = async (fileId) => {
  const url = buildUrl(`/download-processed-file/${fileId}`);

  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders({
      "Content-Type": "application/json",
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(
      errorData.message ||
        `Failed to fetch processed file. Status: ${response.status}`
    );
  }

  const data = await response.json();

  if (data.status === "success") {
    return { signedUrl: data.data.signed_url };
  }

  throw new Error(
    data.message || "An error occurred while fetching the processed file."
  );
};
